<template>
  <v-card>
    <patient-information />
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-form @submit.prevent="undefined">
        <v-card-title
          class="text-h6 text-center"
         
        >
          <h5><v-icon> mdi-calendar </v-icon> Agendar cita</h5>
        </v-card-title>
        <v-card-text>
          <v-container>
            <patient-information :idPatient="idPatient" />
            <div name="specialities">
              <v-banner
                color="blue-grey lighten-5"
                class="mb-4 black--text"
                shaped
                single-line
              >
                Información de cita
              </v-banner>
              <v-row class="text-center">
                <v-col cols="6" class="text-left">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="Fecha cita"
                    rules="required"
                  >
                    <v-text-field
                      v-model.trim="model.appointmentDate"
                      label="Fecha cita*"
                      outlined
                      required
                      autocomplete="off"
                      :error-messages="errors"
                      dense
                      :min="minDateTime"
                      type="datetime-local"
                    >
                      <v-icon slot="append" :color="valid ? 'success' : ''">
                        {{ valid ? " mdi-check" : "" }}
                      </v-icon>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="6">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="Especialidad"
                    rules="required"
                  >
                    <v-autocomplete
                      :items="specialities"
                      label="Especialidad*"
                      outlined
                      clearable
                      required
                      autocomplete="off"
                      :error-messages="errors"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="model.idSpeciality"
                      @change="validateModalities"
                      no-data-text="Sin resultados disponibles."
                      item-text="name"
                      item-value="idSpeciality"
                    >
                      <v-icon slot="append" :color="valid ? 'success' : ''">
                        {{ valid ? " mdi-check" : "" }}
                      </v-icon>
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="Modalidad"
                    rules="required"
                    v-if="isStudy()"
                  >
                    <v-autocomplete
                      :items="modalities"
                      label="Modalidad*"
                      outlined
                      clearable
                      required
                      autocomplete="off"
                      :error-messages="errors"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="model.idModality"
                      @change="validateStudyModality"
                      no-data-text="Sin resultados disponibles."
                      item-text="fullName"
                      item-value="idModality"
                    >
                      <v-icon slot="append" :color="valid ? 'success' : ''">
                        {{ valid ? " mdi-check" : "" }}
                      </v-icon>
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col cols="6">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="Perfil de estudio"
                    rules="required"
                    v-if="isStudy()"
                  >
                    <v-autocomplete
                      :items="studyProfiles"
                      label="Perfil de estudio*"
                      outlined
                      clearable
                      required
                      autocomplete="off"
                      :error-messages="errors"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="model.idStudyModality"
                      no-data-text="Sin resultados disponibles."
                      item-text="fullName"
                      item-value="idStudyModality"
                    >
                      <v-icon slot="append" :color="valid ? 'success' : ''">
                        {{ valid ? " mdi-check" : "" }}
                      </v-icon>
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col col="2" offset="4">
                  <label
                    :class="{
                      'color-sitd': $utilFront.isDarkTheme(),
                      'color-sitd-dark': !$utilFront.isDarkTheme(),
                    }"
                  >
                    Pasar a somatometría
                  </label>
                  <br />
                  <v-btn icon dense>
                    <v-switch v-model="model.goToSomatometry" inset></v-switch>
                  </v-btn>
                </v-col>
                <v-col cols="4"> </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-col class=" justify-space-around">
            <v-menu
              offset-x
              bottom
              left
              :close-on-content-click="true"
              rounded="lg"
            >
              <template v-slot:activator="{ on: menu, attrs }">
                <v-btn
                  type="button"
                  class="mr-12 mb-4"
                  :disabled="sending"
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="{ ...menu }"
                >
                  <v-icon left> mdi-keyboard-backspace </v-icon> Cancelar
                </v-btn>
              </template>
              <v-card>
                <v-list color="grey lighten-3">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <small>
                          ¿Desea <strong>cancelar</strong> el registro actual?
                        </small>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                  <v-btn
                    color="primary"
                    type="button"
                    small
                    block
                    text
                    @click="closeDialog()"
                  >
                    Confirmar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-menu
              offset-x
              bottom
              rigth
              :close-on-content-click="true"
              rounded="lg"
            >
              <template v-slot:activator="{ on: menu, attrs }">
                <v-btn
                  type="button"
                  class="mb-4"
                  :disabled="invalid || sending"
                  v-bind="attrs"
                  v-on="{ ...menu }"
                  color="primary"
                >
                  {{ sending ? "Agendando.." : "Agendar" }}
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-list color="grey lighten-3">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <small>
                          ¿Desea <strong>agendar</strong> el registro actual?
                        </small>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                  <v-btn
                    type="submit"
                    @click="scheduleAppointment()"
                    :disabled="invalid || sending"
                    color="primary"
                    small
                    block
                    text
                  >
                    Confirmar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
        </v-card-actions>
      </v-form>
    </validation-observer>
  </v-card>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import { SpecialityRequest, AppointmentRequest } from "@/core/request/";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Constants from "@/app/core/Constants";
import moment from "moment";

export default {
  name: "ScheduleAppointmentDialog",
  props: {
    idPatient: String,
    closeDialog: Function,
  },
  components: {
    PatientInformation,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      sending: false,
      specialities: [],
      modalities: [],
      studyProfiles: [],
      model: {},
      minDateTime: null,
    };
  },
  created() {
    this.specialities = [];
    SpecialityRequest.listSpecialitiesWithDependencies().then((response) => {
      this.specialities = response.data;
    });
    this.minDateTime = this.$utilFront.getCurrentDateTime();
    this.model.goToSomatometry = true;
    this.model.appointmentDate = this.$utilFront.getCurrentDateTime();
  },
  methods: {
    validateModalities() {
      let newValue = this.model.idSpeciality;
      this.modalities = [];
      this.studyProfiles = [];
      this.model.idModality = null;
      this.model.idStudyModality = null;
      if (this.$utilFront.nonEmpty(newValue)) {
        let speciality = this.specialities.filter((item) => {
          return item.idSpeciality === newValue;
        })[0];
        this.modalities = Object.assign(speciality.modalities, []);
      }
    },
    validateStudyModality() {
      let newValue = this.model.idModality;
      this.studyProfiles = [];
      this.model.idStudyModality = null;
      if (this.$utilFront.nonEmpty(newValue)) {
        let modality = this.modalities.filter((item) => {
          return item.idModality === newValue;
        })[0];
        this.studyProfiles = Object.assign(modality.studyProfiles, []);
      }
    },
    isStudy() {
      let idSpeciality = this.model.idSpeciality;
      if (this.$utilFront.nonEmpty(idSpeciality)) {
        return (
          Constants.SPECIALITY_IMAGE === idSpeciality ||
          Constants.SPECIALITY_LABORATORY === idSpeciality
        );
      }
      return false;
    },
    scheduleAppointment() {
      if (!this.sending) {
        if (moment(this.model.appointmentDate).isBefore(moment(new Date()))) {
          this.$utilFront.notifications(
            "Ingrese una fecha/hora superior",
            "WARNING"
          );
        } else {
          this.sending = true;
          this.model["idPatient"] = this.idPatient;
          AppointmentRequest.scheduleAppointment(this.model)
            .then((response) => {
              this.sending = false;
              let { data, status } = response;
              if (status == 200) {
                this.$utilFront.notifications(
                  "Se ha registrado correctamente.",
                  "SUCCESS"
                );
                this.closeDialog();
              } else {
                data = data || "Ocurrió un error durante el registro.";
                this.$utilFront.notifications(data, "ERROR");
              }
            })
            .catch((e) => {
              this.sending = false;
              this.$utilFront.errorhttp(e);
            });
        }
      }
    },
  },
};
</script>

<style></style>
